module.exports = __webpack_public_path__ + "star1-0845a0732ef2f81077207883dbe947ee.png";